<table>
  <thead>
  <th colspan="3">Read rights</th>
  </thead>
  <thead>
  <th></th>
  <th>Name</th>
  <th>Target</th>
  </thead>
  <tr *ngFor="let right of rights">
    <th><input type="checkbox" (change)="selectRight(right)" [(ngModel)]="right.selected"></th>
    <th>{{right.name}}</th>
    <th>{{right.target}}</th>
  </tr>
</table>
